/*!
 * @license Ranj B.V.
 * Copyright (c) 2020 Ranj B.V. all rights reserved 
 */

 //Vendors
import 'soma.js';
import 'createjs';

//Styles
import './css/style.css';
import './css/fonts.css';

import App from './ranj/app/core/App';
import TextOffsetFixer from './ranj/app/ui/text/TextOffsetFixer';


window.ranj = { DEBUG: DEFINE.DEBUG }; // for backwards compatibility (e.g. ranj.DEBUG)

function init() {
    ranj.TextOffsetFixer = TextOffsetFixer;//place in global scope so skin files can access the module

    const app = new App();
    if (ranj.DEBUG) {
        //Expose app instance globally for debugging
        ranj.app = app;
    }
}

init();